import { Text } from '@chakra-ui/react';
import '@jurnee/common/src/components/Navbar.css';
import { HStack } from '@jurnee/common/src/components/primitives/stack/HStack';
import { VStack } from '@jurnee/common/src/components/primitives/stack/VStack';
import { PayoutBeneficiaryJSON } from '@jurnee/common/src/entities/PayoutBeneficiary';
import { useTranslation } from 'react-i18next';
import { PayoutInformationDrawer } from '../../drawers/PayoutInformationDrawer';

interface Props {
  beneficiary: PayoutBeneficiaryJSON;
  onUpsert(payoutBeneficiary: PayoutBeneficiaryJSON): void;
}

export function PayoutInformation({ beneficiary, onUpsert }: Props) {
  const { t } = useTranslation('common');

  return (
    <VStack w="100%" spacing={3} p={4} bg="white" border="1px solid" borderColor="gray.200" borderRadius={4}>
      <VStack w="100%" spacing={0} alignItems="flex-start">
        <HStack w="100%" justifyContent="space-between">
          <Text fontWeight={700}>{t('fields.legalCompanyName.label')}</Text>
          <PayoutInformationDrawer payoutBeneficiary={beneficiary} onUpsert={onUpsert}>
            <Text variant="link">
              {t('common:buttons.edit')}
            </Text>
          </PayoutInformationDrawer>
        </HStack>
        <Text color="gray.400">{beneficiary.accountName}</Text>
      </VStack>

      <VStack w="100%" spacing={0} alignItems="flex-start">
        <Text fontWeight={700}>{t('fields.bankCountryCode.label')}</Text>

        <Text color="gray.400">{beneficiary.bankCountryCode}</Text>
      </VStack>
    </VStack>
  );
}